import React from "react";

/**
 * 30-day activity heatmap. `days` = array of {date, count}.
 * Renders 7-row × 5-col grid (newest in bottom-right), GitHub-style intensities.
 */
export default function StreakHeatmap({ days = [], currentStreak = 0, totalActive = 0 }) {
  if (!days.length) {
    return (
      <div className="border border-[#fb923c]/40 bg-[#0a0a0a] bg-gradient-to-br from-[#fb923c]/[0.08] to-[#fb923c]/[0.02] p-6 font-mono text-xs tracking-[0.2em] text-[#fb923c]/70 text-center">
        // NO ACTIVITY YET — VISIT A DOSSIER TO BEGIN
      </div>
    );
  }

  // Bucket counts → 5 intensities (0,1-2,3-5,6-10,11+)
  const intensity = (n) => {
    if (n === 0) return 0;
    if (n < 3) return 1;
    if (n < 6) return 2;
    if (n < 11) return 3;
    return 4;
  };
  // Map intensity → bg color (purple ramp)
  const palette = ["#0a0a0a", "#a78bfa20", "#a78bfa50", "#a78bfa90", "#a78bfa"];
  // Use 5-week (~35 day) grid — pad start with empties to align Sun-Sat
  const cells = days.slice(-35);
  return (
    <div data-testid="streak-heatmap" className="border border-[#fb923c]/40 bg-[#0a0a0a] bg-gradient-to-br from-[#fb923c]/[0.10] to-[#fb923c]/[0.02] p-5">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <div className="font-mono text-[10px] tracking-[0.25em] text-[#a78bfa]">
          // 30-DAY HEAT MAP
        </div>
        <div className="font-mono text-[10px] tracking-[0.2em] text-zinc-400 flex items-center gap-3">
          <span><span className="text-[#a78bfa] font-bold">{currentStreak}</span> day streak</span>
          <span className="text-zinc-600">·</span>
          <span><span className="text-white font-bold">{totalActive}</span> active days</span>
        </div>
      </div>
      <div className="grid grid-cols-7 sm:grid-cols-[repeat(35,minmax(0,1fr))] gap-1 max-w-full">
        {cells.map((d) => (
          <div
            key={d.date}
            title={`${d.date} · ${d.count} events`}
            className="aspect-square w-full transition-colors"
            style={{ backgroundColor: palette[intensity(d.count)] }}
          />
        ))}
      </div>
      <div className="mt-3 flex items-center justify-end gap-1.5 font-mono text-[9px] tracking-[0.2em] text-zinc-500">
        <span>LESS</span>
        {palette.map((c, i) => (
          <div key={i} className="w-3 h-3" style={{ backgroundColor: c }} />
        ))}
        <span>MORE</span>
      </div>
    </div>
  );
}
